import { useEffect } from 'react';

type UseGTM = {
  action: string;
  event_category: string;
  event_label: string;
};

export const useGTM = ({
  action,
  event_category,
  event_label,
  fireOnMount,
}: UseGTM & { fireOnMount?: boolean }): {
  fireEvent: (additionalInfo: Record<string, string | number>) => void;
} => {
  const fireEvent = (additionalInfo?: Record<string, string | number>): void => {
    // Google tag manager event tracking
    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push({
      event: action,
      event_category,
      event_label,
      ...additionalInfo,
    });
  };

  useEffect(() => {
    fireOnMount && fireEvent();
  }, []);

  return { fireEvent };
};
